import { BloomLogo } from "@bloom/ui";
import { useLocale } from "../locale/locale-context.tsx";

export function MaintenancePage() {
  const { t } = useLocale();
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-br from-[#fff8fa] via-[#fce6ee] to-[#f4cfdc] px-6 py-16">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 [background:radial-gradient(45rem_30rem_at_15%_10%,rgba(247,200,213,0.55),transparent_60%),radial-gradient(55rem_40rem_at_95%_95%,rgba(233,75,122,0.18),transparent_65%)]"
      />

      {/* Bloom logo watermark — same opacity treatment as the admin login
          watermark, sized to sit behind the card without dominating it. */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 flex items-center justify-center"
      >
        <BloomLogo className="h-[22rem] w-auto text-[var(--brand-rose)] opacity-[0.10] sm:h-[28rem]" />
      </div>

      <div className="relative w-full max-w-md text-center">
        <div className="rounded-[28px] bg-white/80 p-10 shadow-[0_40px_80px_-32px_rgba(233,75,122,0.22)] backdrop-blur-sm">
          <BloomLogo className="mx-auto h-7 w-auto text-[var(--brand-rose)]" />
          <h1 className="mt-6 font-heading text-3xl font-bold leading-tight tracking-tight text-[var(--brand-ink)] sm:text-4xl">
            {t("errors.maintenance.title")}
          </h1>
          <p className="mt-3 text-[15px] leading-relaxed text-[var(--brand-muted)]">
            {t("errors.maintenance.subtitle")}
          </p>
        </div>
      </div>
    </div>
  );
}
